import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const AdditionalHydraulics = ({ additionalHydraulics }: SpecProps<"additional_hydraulics">) => {
  const { i18n } = useLingui();

  if (additionalHydraulics === undefined) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.additionalHydraulics",
    message: "Additional hydraulics",
    comment: "Label for 'Additional hydraulics'",
  });

  return <FieldValuePair field={field} value={additionalHydraulics} />;
};
